<ng-template #inputModal>
    <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="actionCancelled()">
        </button>
    </div>
    <div class="modal-body">
        <ng-content></ng-content>
    </div>
    @if (displayFooter) {
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="actionCancelled()">Cancel</button>
        <button type="button" class="btn btn-bankruptcydata" [innerHTML]="buttonHTML" (click)="advanceToNextStep()"></button>
    </div>
    }
</ng-template>